import axios from 'axios';
import { API_URL } from '@/config';

export async function sendGraphQLQuery<T = any>(
  query: string, 
  variables: Record<string, any> = {}
): Promise<T> {
  const cleanedQuery = query.replace(/\s+/g, ' ').trim();
  
  try {
    const response = await axios.post(API_URL, { 
      query: cleanedQuery, 
      variables 
    });
    
    if (response.data.errors) {
      throw new Error(
        response.data.errors.map((e: any) => e.message).join(', ')
      );
    }
    
    return response.data.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const messages = error.response?.data?.errors?.map((e: any) => e.message);
      throw new Error(messages?.join(', ') || error.message);
    }
    throw error;
  }
}
